import React from 'react';

import StyledCheckbox from './commons/StyledCheckbox';

function Todo(props) {
  const onComplete = (e) => {
    const res = e.target.checked;
    props.onComplete(res);
  };

  // attributes
  const { isComplete } = props;

  // methods

  return (
    <div style={{ borderBottom: 'solid 1px #ddd' }}>
      <StyledCheckbox
        onChange={onComplete}
        value={props.title}
        checked={isComplete}
      ></StyledCheckbox>
    </div>
  );
}

export default Todo;
